import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RoleActivityDTO } from "./role-activity.dto";


export class AllRoleActivityByUserResponseModel extends GlobalResponseObject {
    data?: any;
}




